import React from 'react';
import { useRootTheme } from './hooks';
import { ThemeProvider } from './themeProvider';
export function ThemeColorProvider(props) {
  var children = props.children,
      scheme = props.scheme,
      tone = props.tone;
  var root = useRootTheme();
  return React.createElement(ThemeProvider, {
    scheme: scheme || root.scheme,
    theme: root.theme,
    tone: tone
  }, children);
}